import styled, { css } from 'styled-components';

export const CreditsViewWrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    box-shadow: 0 3px 6px ${theme.shadows.grey.light};
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 24px;
    position: absolute;
    right: 0;
    top: 50px;
    width: 360px;
    z-index: 2;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      width: calc(100% - 40px);
    }
  `}
`;

export const EmptyContainer = styled.div``;


export const CloseButtonWrapper = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
`;

export const CreditsTopText = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-size: ${theme.v2.font.sizes.xxxs};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
  `};
`;

export const CreditsStudioPlan = styled.h4`
  ${({ theme, isProPlan }) => css`
    background: ${isProPlan ? theme.v2.colors.gradient.secondary : theme.v2.colors.gradient.primary};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.bold};
    margin: 0;
    margin-bottom: 8px;
    width: fit-content;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  `};
`;

export const CreditsDescription = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xxs};
    margin: 0;

    a {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `};
`;

export const LearnMoreDescription = styled(CreditsDescription)`
  width: 100%;
  text-align: center;
`;

export const CreditsEstimativeContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 4px;
`;

export const CreditsEstimative = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xxxs};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;

    strong {
      color: ${theme.v2.colors.neutral.lowPure};
      font-size: ${theme.v2.font.sizes.xs};
      font-weight: ${theme.v2.font.weights.bold};
    }
  `};
`;

export const ButtonContainer = styled.div`
  margin: 8px 0;
`;

export const NextCreditsChargeAlert = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background: ${theme.v2.colors.brand.primaryUltraLight};
    border-radius: 17px;
    display: flex;
    gap: 8px;
    margin-bottom: 8px;
    min-height: 34px;
    justify-content: center;
    padding: 8px;
  `};
`;

export const NextCreditsCardText = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xxxs};
    margin: 0;

    strong {
      font-weight: ${theme.v2.font.weights.medium};
    }
  `};
`;
